const appId =
  window.location.hostname === 'www.lootboy.com'
    ? process.env.REACT_APP_ONESIGNAL_APP_ID_COM
    : process.env.REACT_APP_ONESIGNAL_APP_ID_DE;

export function initOneSignal() {
  if (!appId || typeof window.OneSignal.push !== 'function') return;

  window.OneSignal.push(() => {
    Promise.resolve(
      window.OneSignal.init({
        appId,
      }),
    ).catch(() => {});
  });
  window.OneSignal.push(() => {
    window.OneSignal.setSubscription(true);
  });
}

export function sendTags(tags) {
  if (!appId || typeof window.OneSignal.sendTags !== 'function') return;

  window.OneSignal.sendTags(tags);
  if (tags.userId) {
    window.OneSignal.setExternalUserId(tags.userId);
  }
}

export function clearTags() {
  if (!appId || typeof window.OneSignal.push !== 'function') return;

  window.OneSignal.push(() => {
    window.OneSignal.getTags()
      .then((receivedTags) => {
        const tagsToDelete = Object.keys(receivedTags || {});

        if (tagsToDelete.length) {
          return window.OneSignal.deleteTags(tagsToDelete);
        }

        return null;
      })
      .catch(() => {});
  });
}

export default {
  initOneSignal,
  clearTags,
};
